<template>
  <div class="ap">
    <div v-if="loading" class="ap-note">Loading…</div>
    <div v-else-if="error" class="ap-note ap-error">{{ error }}</div>
    <template v-else>
      <div class="ap-head">
        <div>
          <div class="ap-title">{{ page.title }}</div>
          <div v-if="page.description" class="ap-desc">{{ page.description }}</div>
        </div>
        <div class="ap-meta">Saved {{ when }}</div>
      </div>
      <AgentHtmlCard
        :html="page.html"
        :sources="page.sources || []"
        :page-slug="slug"
        class="sensitive"
        data-demo-blur
      />
    </template>
  </div>
</template>

<script>
// A saved page, opened on its own URL with no agent session in sight. It
// renders through the SAME card the conversation uses, so a document behaves
// identically whether it is live in a turn or reopened a month later — and the
// live ones keep working, because the card asks the page's own rows endpoint.
import axios from 'axios';
import AgentHtmlCard from './AgentHtmlCard.vue';

export default {
  name: 'AgentPageView',
  components: { AgentHtmlCard },
  props: { slug: { type: String, required: true } },
  data() {
    return { page: null, loading: true, error: '' };
  },
  computed: {
    when() {
      if (!this.page?.updated_at) return '';
      return new Date(this.page.updated_at).toLocaleString([], {
        month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit',
      });
    },
  },
  async mounted() {
    try {
      const { data } = await axios.get(`/api/impact_analytics/agent-pages/${this.slug}/`);
      this.page = data;
      document.title = `${data.title} | Kairon Health`;
    } catch (error) {
      this.error = error?.response?.status === 404
        ? 'No page with that name.'
        : 'That page could not be loaded.';
    } finally {
      this.loading = false;
    }
  },
};
</script>

<style scoped>
.ap { padding: 24px; background: #f6f5f3; min-height: 100%; }
.ap-head { display: flex; align-items: flex-start; justify-content: space-between; gap: 16px; margin-bottom: 16px; }
.ap-title { font-size: 18px; font-weight: 600; color: #1a1918; }
.ap-desc { font-size: 13px; color: #56534d; margin-top: 2px; }
.ap-meta { font-size: 11.5px; color: #8b877f; white-space: nowrap; }
.ap-note { padding: 32px; font-size: 13px; color: #56534d; }
.ap-error { color: #c23a28; }
</style>
